import React, { useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import { Button, SpinnerIcon, SubTitle } from "../Styles";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import downloadFile from "../../utils/downloadFile";
import ToolTip from "../reuse/ToolTip";

const DetailsWrapper = styled.div`
  padding: 20px;
  border: 1px solid ${({ theme }) => theme.branding.borderColor};
  /* border-radius: 8px; */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  /* gap: 20px; */
  margin-bottom: 20px;
  margin-top: -18px;
  background-color: ${({ theme }) => theme.branding.color};
`;

export default function Vaccination({ requestRecord }) {
  const axiosPrivate = useAxiosPrivate();

  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    try {
      setLoading(true);
      const body = {
        rid: requestRecord?.id_F,
      };
      const response = await axiosPrivate.post("request/download", body);

      const { file, fileName } = response.data;

      downloadFile(file, fileName);
    } catch (err) {
      toast.error("Failed to download | Error al descargar");
    } finally {
      setLoading(false);
    }
  };

  return (
    <DetailsWrapper>
      <SubTitle>
        Download Vaccination Record / Descargar Cartilla de Vacunación
      </SubTitle>

      <Button
        type="submit"
        style={{ width: "250px" }}
        disabled={loading}
        onClick={handleDownload}
        data-tooltip-id="download"
      >
        {loading ? (
          <>
            <SpinnerIcon /> Downloading
          </>
        ) : (
          "Download"
        )}
      </Button>

      <ToolTip text="Descargar" id="download" place="right" />
    </DetailsWrapper>
  );
}
